import Model from "../Model";
import tw from "tailwind-styled-components";
import { SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";
import Config from "../../Config";

const RequestAcceptModal = ({
    setIsReqAccept,
    selectedData,
    refundReqLoading,
    refundReqMutate,

}) => {
    const handleAcceptSubmit = () => {
        refundReqMutate({
            requestId: selectedData?.id,
            status: Config.REQUEST_STATUS.INPROGRESS
        });
    };

    const isLoading = refundReqLoading;

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsReqAccept}
            title="Confirm Accept Request"
        >
            <WarningText>
                Are you sure you want to accept their request?
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn type="button" onClick={() => setIsReqAccept(false)}>
                    Cancel
                </SideCancelBtn>

                <SubmitBtn
                    onClick={handleAcceptSubmit}
                    disabled={isLoading}
                    className="border border-green-500 bg-white text-green-500 hover:bg-green-500 hover:text-white"
                >
                    {isLoading ? "Loading..." : "Accept"}
                </SubmitBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default RequestAcceptModal;
